import React from 'react';
import { CSVLink } from 'react-csv';

import { UxContext } from '@client/context/UxContext';
import { usePageStore } from '@client/store/pageStore/context/pageContext';
import i18n from '@client/utils/i18n';
import { CsvDataPoint, SpectrogramPoint } from '@ledium/types';
import { SpectrogramCsvUpload, SpectrogramUploadResult } from '@ledium/ui-common';
import GetAppIcon from '@mui/icons-material/GetApp';
import { Button, Grid } from '@mui/material';

const LightRecipesCsvUpload = () => {
    const { handleAlert } = React.useContext(UxContext)!;
    const {
        pageState: { formData },
        pageActions
    } = usePageStore();

    const updateStore = (csvData: SpectrogramUploadResult) => {
        pageActions.formData.updateFormItem({ csvData: csvData.rawCsv });
        pageActions.formData.updateFormItem({ spectrogram: csvData.spectrogram });
        pageActions.formData.updateFormItem({ spectrogramRanges: csvData.ranges });
    };

    function onCsvUpload(csvData: SpectrogramUploadResult) {
        const spectrogram = formData.spectrogram as SpectrogramPoint[];
        if (spectrogram.some((e) => e.irradiance > 0)) {
            handleAlert({
                title: i18n('light_recipe_csv_upload_title') as string,
                message: i18n('light_recipe_csv_upload_message') as string,
                okCallback: () => {
                    updateStore(csvData);
                }
            });
        } else {
            updateStore(csvData);
        }
    }

    const csvData = formData.csvData as CsvDataPoint[];

    return (
        !formData.readOnly && (
            <>
                <Grid item xs={6} sx={{ textAlign: 'center' }}>
                    <SpectrogramCsvUpload onUpload={onCsvUpload} />
                </Grid>

                {csvData.length ? (
                    <Grid item xs={6} sx={{ textAlign: 'center' }}>
                        <CSVLink
                            style={{ textDecoration: 'none' }}
                            enclosingCharacter=""
                            filename={`light-recipe${formData.name ? '-' + (formData.name as string) : ''}.csv`}
                            data={csvData}
                        >
                            <Button variant="contained" startIcon={<GetAppIcon />}>
                                <span>{i18n('light_recipe_download_csv')}</span>
                            </Button>
                        </CSVLink>
                    </Grid>
                ) : null}
            </>
        )
    );
};

export default LightRecipesCsvUpload;
